module.exports = __webpack_public_path__ + "static/media/branch-detail-1500.1d3279eb.jpg";